import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import DefaultLink from '../../components/DefaultLink'

export default function HomeTab({tabData}) {
  return (
    <>
      <section className="home-tab-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <h1 className="heading center-heading">AI-Driven Document Management Solutions</h1>
            </div>

            <div className="col-lg-12">
              <Tabs defaultActiveKey="tab-0" id="uncontrolled-tab-example" className="home-tab">
                {tabData?.map((data, index) => (
                  <Tab key={index} eventKey={`tab-${index}`} title={<div className="home-tab-head">
                     <img src={data?.icon} alt="Icon"  loading='lazy'/> <span>{data?.title}</span></div>}>
                    <div className="row align-items-center">
                      <div className="col-lg-5 col-md-6 order-1 order-md-0">
                        <div className="home-tab-content">
                          <h3 className="heading">{data?.heading}</h3>
                          <p>{data?.desc}</p>
                          <DefaultLink to={data?.slug} text='know more'/>
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-6 order-0 order-md-1 wow animate__animated animate__zoomIn" data-wow-duration="0.6s" data-wow-delay="0s">
                        <div className="home-tab-image">
                          <img src={data?.image} alt="Tab" loading='lazy'  />
                        </div>
                      </div>
                    </div>
                  </Tab>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
